module.exports = __webpack_public_path__ + "media/images/pc/static/icon-best-43ed2f482424a4b84f4d88715c15c070.png";